// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.components-CompanyDetails-PaidPlan-styles___paper--lZLDT {
  padding: 32px;
  max-width: 736px;
  margin: 0 0 30px;
}

.components-CompanyDetails-PaidPlan-styles___expenseTravelContainer--XCMUL {
  padding-left: 48px;
  border-top: 1px solid #E0E2E6;
  margin-top: 16px;
}

.components-CompanyDetails-PaidPlan-styles___infoMessage--Sjmi8 {
  border-radius: 4px;
  background-color: #E0EBFF;
  padding: 16px;
  margin-bottom: \$sp3;
  font-size: 12px;
  line-height: 18px;
  display: flex;
  align-items: center;
  color: #1B2432;
}

.components-CompanyDetails-PaidPlan-styles___infoMessage--Sjmi8 svg {
    margin-right: 16px;
  }

.components-CompanyDetails-PaidPlan-styles___isLoading--oTdEe {
  background: #f6f6f7;
  position: relative;
}

.components-CompanyDetails-PaidPlan-styles___infoLoader--KgHN4 {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  right: 0;
}

.components-CompanyDetails-PaidPlan-styles___paidPlanContainer--MlkSP {
  border: 1px solid #dddee0;
  border-radius: 4px; 
  padding-left: 25px;
  padding-right: 25px;
  margin-top: 24px;
}

.components-CompanyDetails-PaidPlan-styles___paidPlanContainer--MlkSP td div:nth-child(2) {
    color: #6D717A;
    font-size: 13px;
    line-height: 8px;
    max-width: -moz-fit-content;
    max-width: fit-content;
    padding-bottom: 9px;
  }

.components-CompanyDetails-PaidPlan-styles___paidPlanContainer--MlkSP td div:first-child {
    color: #1B2432;
    font-size: 15px;
    padding-top: 5px;
  }

.components-CompanyDetails-PaidPlan-styles___confModalStyle--irQkx {
  max-width: -moz-fit-content;
  max-width: fit-content;
}

.components-CompanyDetails-PaidPlan-styles___confModalStyle--irQkx .components-CompanyDetails-PaidPlan-styles___title--HMlJR {
  padding-left: 32px!important;
  padding-right: 32px;
};`, "",{"version":3,"sources":["webpack://./components/CompanyDetails/PaidPlan/styles.pcss"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,cAAc;AAKhB;;AAHE;IACE,kBAAkB;EACpB;;AAGF;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,MAAM;EACN,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAGE;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,2BAAsB;IAAtB,sBAAsB;IACtB,mBAAmB;EACrB;;AAEA;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;;AAGF;EACE,2BAAsB;EAAtB,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;AACpB,CAAA","sourcesContent":[".paper {\n  padding: 32px;\n  max-width: 736px;\n  margin: 0 0 30px;\n}\n\n.expenseTravelContainer {\n  padding-left: 48px;\n  border-top: 1px solid #E0E2E6;\n  margin-top: 16px;\n}\n\n.infoMessage {\n  border-radius: 4px;\n  background-color: #E0EBFF;\n  padding: 16px;\n  margin-bottom: $sp3;\n  font-size: 12px;\n  line-height: 18px;\n  display: flex;\n  align-items: center;\n  color: #1B2432;\n\n  svg {\n    margin-right: 16px;\n  }\n}\n\n.isLoading {\n  background: #f6f6f7;\n  position: relative;\n}\n\n.infoLoader {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  top: 0;\n  right: 0;\n}\n\n.paidPlanContainer {\n  border: 1px solid #dddee0;\n  border-radius: 4px; \n  padding-left: 25px;\n  padding-right: 25px;\n  margin-top: 24px;\n}\n\n.paidPlanContainer td {\n  div:nth-child(2) {\n    color: #6D717A;\n    font-size: 13px;\n    line-height: 8px;\n    max-width: fit-content;\n    padding-bottom: 9px;\n  }\n\n  div:first-child {\n    color: #1B2432;\n    font-size: 15px;\n    padding-top: 5px;\n  }\n}\n\n.confModalStyle {\n  max-width: fit-content;\n}\n\n.confModalStyle .title {\n  padding-left: 32px!important;\n  padding-right: 32px;\n};"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"paper": `components-CompanyDetails-PaidPlan-styles___paper--lZLDT`,
	"expenseTravelContainer": `components-CompanyDetails-PaidPlan-styles___expenseTravelContainer--XCMUL`,
	"infoMessage": `components-CompanyDetails-PaidPlan-styles___infoMessage--Sjmi8`,
	"isLoading": `components-CompanyDetails-PaidPlan-styles___isLoading--oTdEe`,
	"infoLoader": `components-CompanyDetails-PaidPlan-styles___infoLoader--KgHN4`,
	"paidPlanContainer": `components-CompanyDetails-PaidPlan-styles___paidPlanContainer--MlkSP`,
	"confModalStyle": `components-CompanyDetails-PaidPlan-styles___confModalStyle--irQkx`,
	"title": `components-CompanyDetails-PaidPlan-styles___title--HMlJR`
};
module.exports = ___CSS_LOADER_EXPORT___;
